'use es6';

import calculateBasicHoverPositions from './calculateBasicHoverPositions';
const REQUIRED_CONFIG_FIELDS = [];
const validateConfig = config => {
  if (!config || !Array.isArray(config)) {
    throw new Error('buildCalculateHoverPositions requires a config array');
  }
  config.forEach((subConfig, i) => {
    REQUIRED_CONFIG_FIELDS.forEach(field => {
      if (subConfig[field] == null) {
        throw new Error(`Missing required hover position config option: ${field} at ${i}`);
      }
    });
    // Add the index to the config to allow for more useful error logging
    config[i].configIndex = i;
  });
};

/**
 * Returns a calculateHoverPositions function after validating config
 * @param  {Array} config array of config objects sorted by hover position priority (config object options defined below)
 *   @prop {func} getNodePositionsSubset: (optional) returns the relevant node positions
 *   @prop {func} getCustomFields (optional) returns additional fields to include in the node position object
 *   @prop {func} calculateHoverPositions (optional) overrides calculateBasicHoverPositions
 *   @prop {bool} debug (optional) enables console logging
 * @return {func}
 */
export const buildCalculateHoverPositions = config => {
  validateConfig(config);
  /**
   * calculate hover positions for elements, sorted by depth
   * @param {Object} nodePositions {STATIC_MODULES: [{}, {}]}
   * @param {Object} adjustedMouseCoords {clientX: 10, clientY: 10, x: 10, y: 10}
   * @param {Object} extraOptions (optional) extra config to pass to the calculate function
   * @return {Object} hover positions:
   * [
   *  {id: '123', depth: 0, type: 'INNER_TRIANGLE'},
   * ]
   */
  return (nodePositions, adjustedMouseCoords, extraOptions = {}) => {
    if (Object.keys(nodePositions).length === 0) {
      return [];
    }
    let hoverPositionStack = [];
    for (let i = 0; i < config.length; i++) {
      const subConfig = config[i];
      const calculateHoverPositionsFunc = subConfig.calculateHoverPositions ? subConfig.calculateHoverPositions : calculateBasicHoverPositions;
      // Get all the relevant node positions for the calculate func
      const nodePositionsToCheck = subConfig.getNodePositionsSubset ? subConfig.getNodePositionsSubset(nodePositions) : nodePositions;
      if (nodePositionsToCheck) {
        hoverPositionStack = calculateHoverPositionsFunc(nodePositionsToCheck, adjustedMouseCoords, Object.assign({}, subConfig, extraOptions));
      }
      // Break as soon as we have detected any hover positions
      if (hoverPositionStack.length) {
        break;
      }
    }
    return hoverPositionStack;
  };
};